import type { ReactNode } from 'react';

const UserCodeWebWrapper = ({ children }: { children: ReactNode }) => {
  return (
    <div className="flex h-full items-center justify-center px-6">
      <div className="w-[360px] text-center">{children}</div>
    </div>
  );
};

export default UserCodeWebWrapper;
